import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './ProductGrid.module.scss';

interface Props {
  className?: string;
  children: ReactNode;
  variant?: 'plp' | 'watchlist';
}

/**
 * Product grid
 * Each child item should be a `li` element
 */
export const ProductGrid: FC<Props> = ({ children, className, variant = 'plp' }) => (
  <ul className={classNames(styles.root, className, styles[variant])}>{children}</ul>
);
